import React, { useState, useRef } from 'react';

const AddPhotoToCollection = ({ productId, onPhotoAdded, canEdit = true }) => {
  const [photoUrl, setPhotoUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [uploadMethod, setUploadMethod] = useState('file'); // 'url' или 'file'
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  // Загрузка файла на сервер
  const uploadFile = async (file) => {
    console.log('Starting file upload:', file.name, file.size, file.type);
    
    const formData = new FormData();
    formData.append('photo', file);
    formData.append('folder', 'client-photos');

    const token = localStorage.getItem('clientToken');
    console.log('Token exists:', !!token);
    
      const response = await fetch('https://limitverify.ru:5000/api/upload/client/photo', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    
    console.log('Upload response status:', response.status, response.statusText);
    console.log('Upload response headers:', response.headers);
    
    // Логируем сырой ответ
    const responseText = await response.text();
    console.log('Raw response:', responseText);

    if (!response.ok) {
      let errorMessage = 'Ошибка загрузки файла';
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.error || errorMessage;
      } catch (e) {
        // Если не удалось распарсить JSON, используем статус ответа
        console.error('Failed to parse JSON response:', e);
        errorMessage = `Ошибка сервера: ${response.status} ${response.statusText}`;
      }
      throw new Error(errorMessage);
    }

    // Пытаемся распарсить JSON
    let data;
    try {
      data = JSON.parse(responseText);
      console.log('Parsed JSON result:', data);
    } catch (parseError) {
      console.error('JSON parse error:', parseError);
      console.error('Response was not valid JSON:', responseText);
      throw new Error('Server returned invalid JSON response');
    }
    
    return data.url; // Наш endpoint возвращает url
  };

  // Добавление фото в коллекцию
  const addPhotoToCollection = async (photoUrl) => {
    const token = localStorage.getItem('clientToken');
    console.log('Adding photo to collection:', photoUrl);
    
    const response = await fetch('https://limitverify.ru:5000/api/client/photos', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        productId: productId,
        photoUrl: photoUrl,
        displayOrder: 1,
        isPrimary: false
      })
    });

    console.log('Add photo response status:', response.status);
    
    const responseText = await response.text();
    console.log('Add photo raw response:', responseText);

    if (!response.ok) {
      let errorMessage = 'Ошибка добавления фото';
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.error || errorMessage;
      } catch (e) {
        console.error('Failed to parse error JSON:', e);
        errorMessage = `Ошибка сервера: ${response.status}`;
      }
      throw new Error(errorMessage);
    }

    let data;
    try {
      data = JSON.parse(responseText);
      console.log('Add photo parsed result:', data);
    } catch (parseError) {
      console.error('Add photo JSON parse error:', parseError);
      throw new Error('Server returned invalid JSON response');
    }
    
    return data.photo;
  };

  const handleAddPhoto = async (e) => {
    e.preventDefault();
    
    if (uploadMethod === 'url' && !photoUrl.trim()) {
      setError('Введите URL фото');
      return;
    }

    if (uploadMethod === 'file' && !selectedFile) {
      setError('Выберите файл для загрузки');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      let finalPhotoUrl = photoUrl.trim();
      
      // Если выбран файл, загружаем его
      if (uploadMethod === 'file' && selectedFile) {
        finalPhotoUrl = await uploadFile(selectedFile);
      }

      // Добавляем фото в коллекцию
      const photo = await addPhotoToCollection(finalPhotoUrl);
      
      // Очищаем форму
      setPhotoUrl('');
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      
      onPhotoAdded && onPhotoAdded(photo);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Проверяем тип файла
      if (!file.type.startsWith('image/')) {
        setError('Выберите файл изображения');
        return;
      }
      
      // Проверяем размер файла (максимум 50MB)
      if (file.size > 50 * 1024 * 1024) {
        setError('Размер файла не должен превышать 50MB');
        return;
      }
      
      setSelectedFile(file);
      setError('');
    }
  };

  // Если редактирование запрещено, показываем только заголовок
  if (!canEdit) {
    return (
      <div className="add-photo-to-collection" style={{ marginBottom: '20px', textAlign: 'left' }}>
        <h4 style={{ color: '#8c8c8c', fontSize: '16px', fontWeight: '600', marginBottom: '16px', textAlign: 'left' }}>
          Добавить фото в коллекцию
        </h4>
        <div style={{ 
          color: '#8c8c8c', 
          fontSize: '14px', 
          fontStyle: 'italic',
          padding: '10px',
          background: '#1a1a1a',
          borderRadius: '8px',
          border: '1px solid #333'
        }}>
          Управление фото недоступно для архивных товаров
        </div>
      </div>
    );
  }

  return (
    <div className="add-photo-to-collection" style={{ marginBottom: '20px', textAlign: 'left' }}>
      <style>
        {`
          .add-photo-to-collection input[type="file"]::-webkit-file-upload-button {
            background: #8c1913 !important;
            color: white !important;
            border: none !important;
            padding: 8px 16px !important;
            border-radius: 6px !important;
            cursor: pointer !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            margin-right: 8px !important;
            transition: all 0.2s ease !important;
          }
          
          .add-photo-to-collection input[type="file"]::-webkit-file-upload-button:hover {
            background: #a01e16 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 2px 4px rgba(140, 25, 19, 0.3) !important;
          }
          
          .add-photo-to-collection input[type="file"]::-webkit-file-upload-button:active {
            transform: translateY(0) !important;
          }
          
          .add-photo-to-collection input[type="file"]::-moz-file-upload-button {
            background: #8c1913 !important;
            color: white !important;
            border: none !important;
            padding: 8px 16px !important;
            border-radius: 6px !important;
            cursor: pointer !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            margin-right: 8px !important;
            transition: all 0.2s ease !important;
          }
          
          .add-photo-to-collection input[type="file"]::-moz-file-upload-button:hover {
            background: #a01e16 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 2px 4px rgba(140, 25, 19, 0.3) !important;
          }
        `}
      </style>
      <h4 style={{ color: '#e8e8e8', fontSize: '16px', fontWeight: '600', marginBottom: '16px', textAlign: 'left' }}>Добавить фото в коллекцию</h4>
      
      {error && (
        <div style={{ color: '#ff4d4f', marginBottom: '10px', textAlign: 'left' }}>
          {error}
        </div>
      )}

      {/* Переключатель метода загрузки */}
      <div style={{ marginBottom: '15px', textAlign: 'left' }}>
        <label style={{ marginRight: '20px', cursor: 'pointer', color: '#e8e8e8', display: 'inline-block' }}>
          <input
            type="radio"
            name="uploadMethod"
            value="file"
            checked={uploadMethod === 'file'}
            onChange={(e) => setUploadMethod(e.target.value)}
            style={{ marginRight: '5px' }}
          />
          С устройства
        </label>
        <label style={{ cursor: 'pointer', color: '#e8e8e8', display: 'inline-block' }}>
          <input
            type="radio"
            name="uploadMethod"
            value="url"
            checked={uploadMethod === 'url'}
            onChange={(e) => setUploadMethod(e.target.value)}
            style={{ marginRight: '5px' }}
          />
          По URL
        </label>
      </div>

      <form onSubmit={handleAddPhoto}>
        {uploadMethod === 'url' ? (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#e8e8e8', fontWeight: '500', textAlign: 'left' }}>
                URL фото:
              </label>
              <input
                type="url"
                value={photoUrl}
                onChange={(e) => setPhotoUrl(e.target.value)}
                placeholder="https://example.com/photo.jpg"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '2px solid #1a472a',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#0a0c0e',
                  color: '#e8e8e8',
                  outline: 'none',
                  transition: 'all 0.2s ease'
                }}
                disabled={loading}
                onFocus={(e) => {
                  e.target.style.borderColor = '#8c1913';
                  e.target.style.boxShadow = '0 0 0 2px rgba(140, 25, 19, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#1a472a';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
            <button
              type="submit"
              disabled={loading || !photoUrl.trim()}
              style={{
                background: loading ? '#d9d9d9' : '#8c1913',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                height: '40px',
                transition: 'all 0.3s ease',
                boxShadow: loading ? 'none' : '0 2px 4px rgba(140, 25, 19, 0.2)'
              }}
              onMouseEnter={(e) => {
                if (!loading && photoUrl.trim()) {
                  e.target.style.background = '#a01e16';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(140, 25, 19, 0.3)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && photoUrl.trim()) {
                  e.target.style.background = '#8c1913';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(140, 25, 19, 0.2)';
                }
              }}
            >
              {loading ? 'Добавление...' : 'Добавить'}
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
            <div style={{ flex: 1 }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#e8e8e8', fontWeight: '500', textAlign: 'left' }}>
                Выберите файл:
              </label>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileSelect}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '2px solid #1a472a',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#0a0c0e',
                  color: '#e8e8e8',
                  outline: 'none',
                  transition: 'all 0.2s ease'
                }}
                disabled={loading}
                onFocus={(e) => {
                  e.target.style.borderColor = '#8c1913';
                  e.target.style.boxShadow = '0 0 0 2px rgba(140, 25, 19, 0.2)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#1a472a';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
            <button
              type="submit"
              disabled={loading || !selectedFile}
              style={{
                background: loading ? '#d9d9d9' : '#8c1913',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                height: '40px',
                transition: 'all 0.3s ease',
                boxShadow: loading ? 'none' : '0 2px 4px rgba(140, 25, 19, 0.2)'
              }}
              onMouseEnter={(e) => {
                if (!loading && selectedFile) {
                  e.target.style.background = '#a01e16';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(140, 25, 19, 0.3)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading && selectedFile) {
                  e.target.style.background = '#8c1913';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(140, 25, 19, 0.2)';
                }
              }}
            >
              {loading ? 'Загрузка...' : 'Загрузить'}
            </button>
          </div>
        )}
      </form>
      
      <div style={{ fontSize: '12px', color: '#b5b9bf', marginTop: '5px', fontWeight: '500', textAlign: 'left' }}>
        Вы можете добавить фото изделия в свою коллекцию. Удалить можно только свои фото.
        {uploadMethod === 'file' && ' Поддерживаются форматы: JPG, PNG, GIF. Максимальный размер: 50MB.'}
      </div>
    </div>
  );
};

export default AddPhotoToCollection;
